import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { NavbarComponent } from '../../../shared/components/navbar/navbar.component';
import { TransportMapComponent } from '../../components/transport-map/transport-map.component';


@Component({
  selector: 'app-map-transport-page',
  standalone: true,
  imports: [TransportMapComponent, RouterModule, DialogModule, NavbarComponent],
  templateUrl: './map-transport-page.component.html'
})
export class MapTransportPageComponent {

  constructor(private _cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this._cdr.detectChanges();
  }
}
